import { useCallback, useMemo, useState } from "react"
import { TextMatch } from "shared/text"
import { useListSearch } from "interface/search"
import { SearchListWithManufacturer } from 'features/search/types'

export const useSearchListContainer = () => {
  const [searchWord, setSearchWord] = useState('')

	const [searchReloadTime, setSearchReloadTime] = useState<Date | undefined>(undefined)
  const listState = useListSearch({ partialLimit: 10 }, [searchReloadTime])
	const reloadList = useCallback(
		() => setSearchReloadTime(new Date()),
		[setSearchReloadTime]
	)
  const manufacturerList = useMemo<SearchListWithManufacturer[] | null>(
		() => {
			if (!listState.data) return null

			let list = listState.data
			if (searchWord !== '') {
				const match = new TextMatch(searchWord)
				list = list.filter(r => {
					const keyWord = [r.title, r.description]
					return match.match(...keyWord)
				})
			}
			const manufacturerList: SearchListWithManufacturer[] = []
			list.forEach(search => {
				let manufacturer = manufacturerList.find(
					sp => sp.manufacturerId === search.manufacturer?.manufacturerId
				)
				if (!manufacturer) {
					manufacturer = {
						manufacturerId: search.manufacturer?.manufacturerId ?? 0,
						manufacturerName: search.manufacturer?.manufacturerName ?? 'ケアネット',
						updateTime: search.manufacturer?.updateTime ?? null,
						searchList: [],
					}
					manufacturerList.push(manufacturer)
				}
				manufacturer.searchList.push(search)
			})
			return manufacturerList
		},
		[listState.data, searchWord]
	)
	return useMemo(() => ({
		searchWord,
		setSearchWord,
		loading: listState.loading,
		error: listState.error,
		reloadList,
		manufacturerList,
	}), [
		searchWord,
		setSearchWord,
		listState,
		reloadList,
		manufacturerList
	])
}